import axios from 'settings/axios'
import qs from 'querystring'

import { apiEndpoints } from 'settings/_apiSettings'
import { PATIENT_NO_SHOW, CANCELED } from 'settings/_scheduleStatusSettings'
interface ScheduleStatusParams {
  initialDate: string
  endDate: string
  scheduleStatusCode: 
    typeof PATIENT_NO_SHOW | 
    typeof CANCELED
  reasonCode?: string[]
}

export interface Patients {
  full_name: string,
  username: string,
  cellphone_number: string,
  schedule_count: number,
  plan_group_name: string,
  allows_reservation: boolean,
  has_reservation: boolean
}

export interface ScheduleData {
  patients: Patients[]
  status_name: string
}

export const getListSchedulesByStatus = async({
  initialDate,
  endDate,
  scheduleStatusCode,
  reasonCode
}: ScheduleStatusParams): Promise<ScheduleData> => {
  const endpoint = apiEndpoints.METRICS_PATIENTS_SCHEDULE_STATUS

  const params = {
    start_date__gte: initialDate,
    start_date__lte: endDate,
    status_code: scheduleStatusCode,
    ...(reasonCode && { reason_code: reasonCode })
  }

  const { data } = await axios.get<ScheduleData>(endpoint, { 
    params, 
    paramsSerializer: params => {
      return qs.stringify(params)
    },
  })
  return data
}